export default "__VITE_ASSET__CXU$jyNU__"